//  Sign out and error boundary use this to do a "hard" reset:
//  - Wipe out any persistent state
//  - Reload window
//  - Navigate to /
export default function bail() {
  if (typeof window !== 'undefined') {
    window.sessionStorage.clear();
    window.localStorage.clear();
    // This will reload the document (clear the global state), and also redirect
    // user to the root page, so they can sign in again
    window.location.replace(window.location.pathname);
  }
}
